(function(){
  'use strict';

  angular.module('irricrops')


  .factory("fertilizacionRes", ['urls', '$resource', function(urls, $resource){
    return $resource(urls.BASE+'/fertilizacion/:action', {},{
      get:{
        method: 'GET',
        cache: true
      },

      getVinedo:{
        method: 'GET',
        params:{
          action: 'vinedo'
        }
      },


      getElementos:{
        method: 'GET',
        params:{
          action: 'elementos'
        }
      },


      postEtapaPrograma:{
        method: "POST",
        params:{
          action: "programa"
        }
      },

      deleteEtapaPrograma:{
        method: "DELETE",
        params:{
          action: "programa"
        }
      },





      postEtapas:{
        method: "POST",
        params:{
          action: "etapa"
        }
      },

      deleteEtapas:{
        method: "DELETE",
        params:{
          action: "etapa"
        }
      },
      getEtapas:{
        method: "GET",
        params:{
          action: "etapa"
        }
      },





      postPrograma:{
        method: "POST",
        params:{
          action: "programa-fertilizacion"
        }
      },

      deleteProgram:{
        method:"DELETE",
        params:{
          action:"programa-fertilizacion"
        }
      },

      postAplicacion:{
        method:"POST",
        params:{
          action:"aplicacion"
        }
      },

      postElement:{
        method:"POST",
        params:{
          action:"elemento"
        }
      },

      postProducto:{
        method:"POST",
        params:{
          action:"producto"
        }
      },

      deleteProducto:{
        method:"DELETE",
        params:{
          action:"producto"
        }
      }




    });
  }])

})();
